import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LeftHandPanelDefaultFilterService } from '../../services/left-hand-panel-default-filter.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { AuditableModel } from '../../../../Common/Misc/models/auditable.model';
import { UserAppPreferenceCommonFilters } from '../../../../Core/Users/models/user-app-preferences-filters.model';
import { AuditableFiltersModel } from '../../../../Common/Filter/models/auditable-filters.model';


@Component({
    selector: 'agpr-left-hand-panel-default-filter',
    templateUrl: './left-hand-panel-default-filter.component.html',
    providers: [
        {
            provide: FilterService,
            useClass: LeftHandPanelDefaultFilterService
        }
    ],
    standalone: false
})
export class LeftHandPanelDefaultFilterComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @Input() items: AuditableModel[];
    @Input() defaultFilters: AuditableFiltersModel;
    @Input() initialValues: UserAppPreferenceCommonFilters;
    @Input() ariaLabelledBy: string;

    @Output() filterChange = new EventEmitter<{
        originalFilters: UserAppPreferenceCommonFilters;
        newFilters: UserAppPreferenceCommonFilters;
    }>();

    private getAllFiltersSubscribe: Subscription;
    private hasInited: boolean = false;

    constructor(
        public filterService: FilterService
    ) {}

    ngOnInit(): void {
        this.getAllFiltersSubscribe = (<LeftHandPanelDefaultFilterService> this.filterService)
            .addFilters(this.defaultFilters.getAllFilters())
            .pipe(
                tap(filters => {
                    if (!this.hasInited) {
                        // On init we need to set all the initial filter values, then re-emit so the filter-dropdown
                        // has the latest values as well
                        this.defaultFilters.setAllFilters(filters, this.initialValues);
                        this.hasInited = true;
                        (<LeftHandPanelDefaultFilterService> this.filterService).emitFilters(filters);
                    } else {
                        this.defaultFilters.setNewValues(filters);
                        this.filterChange.emit({
                            originalFilters: this.initialValues,
                            newFilters: this.defaultFilters.getFilterValues(),
                        });
                    }
                })
            )
            .subscribe();

        (<LeftHandPanelDefaultFilterService> this.filterService).getAuditableFilterOptions(this.items);
    }

    ngOnDestroy(){
        this.getAllFiltersSubscribe?.unsubscribe();
    }
}
